<script lang="ts" setup>
    import { __ } from '@/js/stores/expressions';
    import { InfoIcon } from '@lucide/vue';

    defineProps<{
        hasData: boolean;
    }>();
</script>

<template>
    <template v-if="hasData">
        <slot />
    </template>
    <template v-else>
        <div class="flex p-4 pt-0">
            <div
                class="bg-gray-extralight border border-gray-lightest p-4 text-gray-medium rounded-md grow w-full items-center flex justify-center flex-col gap-2 text-body"
            >
                <InfoIcon />
                <p class="text-center">{{ __('widget-has-no-data') }}</p>
            </div>
        </div>
    </template>
</template>
